export const getLifecycleBrowserTimezone = () => {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!timeZone || (timeZone !== 'UTC' && !timeZone.includes('/'))) return null;
    new Intl.DateTimeFormat('en-US', { timeZone }).format();
    return timeZone;
  } catch (error) {
    return null;
  }
};
